
import { PropType } from 'vue';

interface CouponStatistics {
  total: number;
  amount: string;
}

export default {
  name: 'coupon-statistics',
  props: {
    visible: {
      required: false,
      type: Boolean,
      default: true,
    },
    disableReport: {
      required: false,
      type: Boolean,
      default: true,
    },
    enableClear: {
      required: false,
      type: Boolean,
      default: false,
    },
    approvedTotal: {
      required: true,
      type: Object as PropType<CouponStatistics>,
    },
    rejectedTotal: {
      required: true,
      type: Object as PropType<CouponStatistics>,
    },
    unprocessedTotal: {
      required: true,
      type: Object as PropType<CouponStatistics>,
    },
  }
};
